import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import GenericModal from '../../../components/modal/GenericModal';

const ValidarVacuna = ({ toggleModal}) => {

    const history = useHistory();

    const Continuar = async () => {
        history.push("/");
    };

    return (
        <GenericModal showModal={() => {Continuar(); toggleModal()}} width={"600px"} titulo={"Validación de Confirmación"}>
            <div>
                <p>El registro de vacunación ya fue confirmado por usted anteriormente.</p>
                <button className="btn btn-primary generic-button-ficha" onClick={Continuar}>Continuar</button>
            </div>
        </GenericModal>
    )
}

export default ValidarVacuna;